module.exports = __webpack_public_path__ + "assets/media/video-convo.1874d969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/video-convo.jpg
// module id = 3242
// module chunks = 0